import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotUsingCreditsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NotUsingCredits",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M29.66 22.82c-.15 0-.3-.03-.44-.09a1.14 1.14 0 0 1-.61-1.5c.69-1.66 1.05-3.43 1.05-5.25 0-7.54-6.13-13.67-13.67-13.67-1.82 0-3.59.35-5.26 1.05a1.14 1.14 0 0 1-1.49-.61c-.24-.58.03-1.25.61-1.49A15.7 15.7 0 0 1 15.98.03c8.8 0 15.95 7.16 15.95 15.95 0 2.13-.41 4.19-1.22 6.14-.18.44-.61.7-1.05.7M15.98 31.93C7.19 31.93.03 24.78.03 15.98c0-2.13.41-4.19 1.22-6.14.24-.58.91-.86 1.49-.61.58.24.86.91.61 1.49-.69 1.66-1.05 3.43-1.05 5.26 0 7.54 6.13 13.67 13.67 13.67 1.82 0 3.59-.35 5.26-1.05.58-.24 1.25.03 1.49.62.24.58-.03 1.25-.62 1.49a15.9 15.9 0 0 1-6.13 1.22ZM28.51 29.66c-.29 0-.58-.11-.81-.33L2.65 4.26c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0L29.33 27.7a1.14 1.14 0 0 1-.81 1.95Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.98 27.38c-6.28 0-11.4-5.11-11.4-11.39a1.14 1.14 0 1 1 2.28 0c0 5.02 4.09 9.11 9.11 9.11a1.14 1.14 0 1 1 0 2.28ZM23.62 10.29c-.31 0-.63-.13-.85-.38a9.13 9.13 0 0 0-6.79-3.04 1.14 1.14 0 1 1 0-2.28c3.24 0 6.33 1.38 8.49 3.8a1.14 1.14 0 0 1-.85 1.9"
    })]
  }));
};